import React from 'react';
import ProtectedRoute from '../../components/ProtectedRoute/ProtectedRoute';
import QuizPage from '../../features/quiz/components/QuizPage';

const WebsiteQuizRoute = () => {
  return (
    <ProtectedRoute requiresAuth={true}>
      <QuizPage />
    </ProtectedRoute>
  );
};

export default WebsiteQuizRoute;
